import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const ciljeviAdapter = createEntityAdapter({})

const initialState = ciljeviAdapter.getInitialState()

export const ciljeviApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        //Primarni ciljevi
        getAllCiljevi: builder.query({
            query: () => ({
                url: '/ciljevi',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedCiljevi = responseData.map(cilj => {
                    cilj.id = cilj._id
                    return cilj
                });
                return ciljeviAdapter.setAll(initialState, loadedCiljevi)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Cilj', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Cilj', id }))
                    ]
                } else return [{ type: 'Cilj', id: 'LIST' }]
            }
        }),
        addNewCilj: builder.mutation({
            query: initialUserData => ({
                url: '/ciljevi',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'Cilj', id: "LIST" }
            ]
        }),
        updateCilj: builder.mutation({
            query: initialUserData => ({
                url: '/ciljevi',
                method: 'PATCH',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Cilj', id: arg.id }
            ]
        }),
        deleteCilj: builder.mutation({
            query: ({ id }) => ({
                url: `/ciljevi`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Cilj', id: arg.id }
            ]
        }),

        //Spec ciljevi
        getAllSpecCiljevi: builder.query({
            query: () => ({
                url: '/ciljevi/specificni',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedCiljevi = responseData.map(cilj => {
                    cilj.id = cilj._id
                    return cilj
                });
                return ciljeviAdapter.setAll(initialState, loadedCiljevi)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'SpecCilj', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'SpecCilj', id }))
                    ]
                } else return [{ type: 'SpecCilj', id: 'LIST' }]
            }
        }),
        getAllSpecCiljNames: builder.query({
            query: () => ({
                url: '/ciljevi/names',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
        }),
        addNewSpecCilj: builder.mutation({
            query: initialUserData => ({
                url: '/ciljevi/specificni',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'SpecCilj', id: "LIST" }
            ]
        }),
        updateSpecCilj: builder.mutation({
            query: initialUserData => ({
                url: '/ciljevi/specificni',
                method: 'PATCH',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'SpecCilj', id: arg.id }
            ]
        }),
        deleteSpecCilj: builder.mutation({
            query: ({ id }) => ({
                url: `/ciljevi/specificni`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'SpecCilj', id: arg.id }
            ]
        }),

        //Motivacija
        getAllMotivacije: builder.query({
            query: () => ({
                url: '/ciljevi/motivacije',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedCiljevi = responseData.map(cilj => {
                    cilj.id = cilj._id
                    return cilj
                });
                return ciljeviAdapter.setAll(initialState, loadedCiljevi)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Motivacija', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Motivacija', id }))
                    ]
                } else return [{ type: 'Motivacija', id: 'LIST' }]
            }
        }),
        addNewMotivacija: builder.mutation({
            query: initialUserData => ({
                url: '/ciljevi/motivacije',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'Motivacija', id: "LIST" }
            ]
        }),
        updateMotivacija: builder.mutation({
            query: initialUserData => ({
                url: '/ciljevi/motivacije',
                method: 'PATCH',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Motivacija', id: arg.id }
            ]
        }),
        deleteMotivacija: builder.mutation({
            query: ({ id }) => ({
                url: `/ciljevi/motivacije`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Motivacija', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetAllCiljeviQuery,
    useAddNewCiljMutation,
    useUpdateCiljMutation,
    useDeleteCiljMutation,

    useGetAllSpecCiljeviQuery,
    useGetAllSpecCiljNamesQuery,
    useAddNewSpecCiljMutation,
    useUpdateSpecCiljMutation,
    useDeleteSpecCiljMutation,

    useGetAllMotivacijeQuery,
    useAddNewMotivacijaMutation,
    useUpdateMotivacijaMutation,
    useDeleteMotivacijaMutation

    
} = ciljeviApiSlice